import { Button, Col, DatePicker, Input, Modal, Row, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import apiPath from "../../constants/apiPath";
import useRequest from "../../hooks/useRequest";

import { Select } from "antd";
const { Option } = Select;

const { RangePicker } = DatePicker;

const Search = Input.Search;

let baseURL = apiPath.CertifiedPractitioner;

function CertifiedPractitionerList({ type }) {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowFilter, setRowFilter] = useState({});
  useState(false);
  const [file, setFile] = useState([]);
  const [certificateModalVisible, setCertificateModalVisible] = useState(false);
  const [certificateCP, setCertificateCP] = useState(null);
  const [image, setImage] = useState(null);
  const [cpModalVisible, setCpModalVisible] = useState(false);
  const [mfList, setMfList] = useState([]);

  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const columns = [
    {
      title: "Name",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },

    {
      title: "STATUS",
      key: "isActive",
      render: (_, { is_deleted, isActive, _id }) => {
        let color = is_deleted ? "red" : isActive ? "green" : "red";
        return (
          <Tag color={color} key={isActive}>
            {is_deleted ? "DELETED" : isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
    {
      title: "Master Facilitator",
      key: "master_practitioner",
      render: (_, { master_practitioner }) => {
        const practitioners = master_practitioner || [];
        return (
          <div>
            {practitioners.slice(0, 2).map((mp) => (
              <Tag key={mp._id}>{mp.name || mp.userName || "N/A"}</Tag>
            ))}
            {practitioners.length > 2 && (
              <Button
                size="small"
                type="link"
                onClick={() => {
                  setMfList(practitioners);
                  setCpModalVisible(true);
                }}
              >
                +{practitioners.length - 2} more
              </Button>
            )}
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    if (certificateModalVisible && certificateCP?.certifications) {
      setImage(certificateCP.certifications);
    }
  }, [certificateModalVisible, certificateCP]);

  const navigate = useNavigate();
  const { confirm } = Modal;

  useEffect(() => {
    fetchData(pagination);
  }, []);

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/list?status=${
        filterActive ? filterActive.join(",") : ""
      }&page=${pagination ? pagination.current : 1}&limit=${5}}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
      <Modal
        title="All Master Facilitators"
        open={cpModalVisible}
        onCancel={() => setCpModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setCpModalVisible(false)}>
            Close
          </Button>,
        ]}
      >
        <ul>
          {mfList.map((mf) => (
            <li key={mf._id}>{mf.name || mf.userName || "N/A"}</li>
          ))}
        </ul>
      </Modal>
    </>
  );
}

export default CertifiedPractitionerList;
